import { mapStyles, mapStyleTypes } from '../utils/constants/map-styles';

const initialState = {
  zoom: 1,
  center: [0, 0],
  geolocation: null,
  style: mapStyles[mapStyleTypes.streets],
};

const Actions = {
  MAPBOX_GL_VIEWPORT_CHANGED: 'mapbox-gl/viewport-changed',
  MAPBOX_GL_INITIALIZED: 'mapbox-gl/initialized',
  MAPBOX_GL_GEOLOCATION_CHANGED: 'mapbox-gl/geolocation-changed',
  MAPBOX_GL_STYLE_CHANGED: 'mapbox-gl/style-changed',
};

const viewportChanged = ({ zoom, center }) => ({
  type: Actions.MAPBOX_GL_VIEWPORT_CHANGED,
  zoom,
  center,
});

const initialized = ({ zoom, center }) => ({
  type: Actions.MAPBOX_GL_INITIALIZED,
  zoom,
  center,
});

const geolocationChanged = (coords) => ({
  type: Actions.MAPBOX_GL_GEOLOCATION_CHANGED,
  geolocation: coords,
});

const styleChanged = (style) => ({
  type: Actions.MAPBOX_GL_STYLE_CHANGED,
  style: style,
});

function reducer(state = initialState, action) {
  switch (action.type) {
    case Actions.MAPBOX_GL_VIEWPORT_CHANGED:
      return { ...state, center: action.center, zoom: action.zoom };
    case Actions.MAPBOX_GL_INITIALIZED:
      return { ...state, center: action.center, zoom: action.zoom };
    case Actions.MAPBOX_GL_GEOLOCATION_CHANGED:
      return { ...state, geolocation: action.geolocation };
    case Actions.MAPBOX_GL_STYLE_CHANGED:
      return { ...state, style: action.style };
  }
  return state;
}

function selectCenter(state) {
  return state.mapboxGl.center;
}

const selectZoom = (state) => state.mapboxGl.zoom;

const selectGeolocation = (state) => state.mapboxGl.geolocation;

const selectStyle = (state) => state.mapboxGl.style;

export {
  reducer,
  viewportChanged,
  initialized,
  geolocationChanged,
  styleChanged,
  selectZoom,
  selectCenter,
  selectGeolocation,
  selectStyle,
};
